<template>
<div id="policy-overlay" class="bg-grey" v-if="message && shown">
    <div class="container">
        <div class="columns is-mobile is-vertical-centred">
            <div class="column is-2">
                <img alt="cookie" src="@/assets/cookie.svg" />
            </div>
            <div class="column">
                <div class="content" v-html="message"></div>
                <p><button @click.prevent="close" class="button is-primary">OK</button></p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name    :   'PolicyOverlay',
    props   :   ['message'],
    data()
    {
        return {
            shown   :   true
        }
    },
    methods :   {
        close()
        {
            this.shown  =   false;
            axios.post(
                base_url + endpoints.policy
            );
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/PolicyOverlay.vue